
export const NODE_SIZE = 70;
const NODE_SPACE_X = 80;
const NODE_SPACE_Y = 80;
const NODE_HALFSIZE = NODE_SIZE / 2;
const ARC_WIDTH = 2;
const ARC_ARROW_SIZE = 16;
const ARC_COLOR = "#000000";
const ARC_TEXT_COLOR = "#000000";
const ARC_TEXT_SIZE = 12;
const ARC_INV_COLOR = "#0000AA";
const ARC_INV_TEXT_COLOR = "#0000AA";
const ARC_INV_TEXT_SIZE = 12;
const BKG_COLOR = "#F2F2F2";//"#7F7F7F";

let clonedData = null;
let normData = null;
let maxTreeLevels = 0;
let lastOffsetForLevel = [];
let totalWeight = 0;
let totalSizeW = 0;
let totalSizeH = 0;
let selectedNode = null;
let data = null;
let lastViewportTransform = null;

let lines = [];
let lineThick = 5;

export function drawGraphToCanvas(context, container, graphData, graphSelectedNode, canvasScale, viewportTransform) {

  data = graphData;
  selectedNode = graphSelectedNode;


  normalizeGrafo();
  totalWeight = calculateWeight(normData);
  totalSizeW = totalWeight * (NODE_SIZE + NODE_SPACE_X);
  totalSizeH = ((maxTreeLevels + 1) * (NODE_SIZE + NODE_SPACE_Y)) + 10;
  if (container.offsetWidth > totalSizeW) {
    totalSizeW = container.offsetWidth;
  }
  /*
  console.log(normData);
  console.log("maxTreeLevels="+maxTreeLevels+"   totalWeight="+totalWeight);
  console.log("totalSizeW="+totalSizeW+"   totalSizeH="+totalSizeH);
  console.log("canvasScale="+canvasScale);
*/
  //console.log("container.offsetWidth",container.offsetWidth);

  processNodeRecursive(context, normData, null, NODE_SIZE);

  let containerWidth = container.clientWidth;
  let containerHeight = container.clientHeight;
  let graphW = totalSizeW * canvasScale;
  let graphH = totalSizeH * canvasScale;
  context.canvas.width = containerWidth; //graphW;
  context.canvas.height = graphH;
  clearCanvas(context);

  //context.setTransform(canvasScale, 0, 0, canvasScale, 0, 0);

  context.setTransform(1, 0, 0, 1, 0, 0);
  context.clearRect(0, 0, context.canvas.width, context.canvas.height);

  if (
    (viewportTransform.x < totalSizeW && viewportTransform.x > -totalSizeW) &&
    (viewportTransform.y < totalSizeH && viewportTransform.y > -totalSizeH)
  ) {
    lastViewportTransform = viewportTransform;
    context.setTransform(canvasScale, 0, 0, canvasScale, viewportTransform.x, viewportTransform.y);
  }
  else {
    if (lastViewportTransform != null) {
      context.setTransform(canvasScale, 0, 0, canvasScale, viewportTransform.x, viewportTransform.y);
    }
    else {
      context.setTransform(canvasScale, 0, 0, canvasScale, 0, 0);
    }

  }




  //DRAW
  lines = [];
  lineThick = 5 * canvasScale;
  lastOffsetForLevel = [];
  drawGrafo(context, clonedData);

}



function clearCanvas(context) {
  context.fillStyle = BKG_COLOR;
  context.fillRect(0, 0, context.canvas.width, context.canvas.height);
}




function drawGrafo(context, clonedData) {
  drawArcs(context, clonedData);
  drawNodes(context, clonedData);
}

function drawNodes(context, clonedData) {
  if (clonedData != null && clonedData.length > 0) {
    for (var i = 0; i < clonedData.length; i++) {
      let nodo = clonedData[i];
      drawNode(context, nodo, NODE_SIZE)
    }
  }
}

function drawArcs(context, clonedData) {
  lines = [];
  if (clonedData != null && clonedData.length > 0) {
    for (var i = 0; i < clonedData.length; i++) {
      let nodo = clonedData[i];
      if (nodo.archi != null && nodo.archi.length > 0) {
        for (var j = 0; j < nodo.archi.length; j++) {
          let arc = nodo.archi[j];
          if (arc != null) {
            let endNode = findNodo(arc.idNodoEnd);
            drawArc(context, arc, nodo, endNode);
          }
        }
      }
    }
  }
}


function drawNode(context, node, nodeSize) {

  if (node != null) {
    let fillColor = "#FFFFFF"; //"#514429";
    let borderColor = "#000000"; //"#916615";
    let textColor = "#000000"; //"#FFFFFF";
    let label = "";
    let borderSize = 4;
    let font = "12px Arial";

    if (selectedNode != null && node.idNodo === selectedNode.idNodo) {
      label = node.descNodo;
      fillColor = "#F5EF8D";// "#897C60";
      borderColor = "#000000"; //"#FFFFFF";
      borderSize = 8;
    }
    else {
      label = node.descNodo;
    }

    if (node.nodoStart) {
      label = "START";
      fillColor = "#80FF80"; //"#DE9300";
      borderColor = "#000000"; //"#916615";
      font = "bold 15px Arial";
    }

    context.beginPath();
    //context.fillRect(node.posX, node.posY, NODE_HALFSIZE*3, NODE_HALFSIZE*1.5);
    context.arc(node.posX + NODE_HALFSIZE, node.posY + NODE_HALFSIZE, NODE_HALFSIZE, 0, 2 * Math.PI);
    context.fillStyle = fillColor;
    context.fill();
    context.lineWidth = borderSize;
    context.strokeStyle = borderColor;
    context.stroke();

    context.save();

    context.beginPath();

    context.rect(node.posX, node.posY, NODE_SIZE, NODE_SIZE);
    context.font = font;
    context.fillStyle = textColor;
    context.textAlign = "center";
    context.fillText(label, node.posX + NODE_HALFSIZE, node.posY + NODE_HALFSIZE + 6);
    context.clip();

    context.closePath();

    context.restore();

  }
}


function drawArc(context, arc, startNode, endNode) {
  if (arc != null && startNode != null && endNode != null) {
    // Start a new Path
    //canvas_arrow(context, startNode.posX+NODE_HALFSIZE, startNode.posY+NODE_HALFSIZE, endNode.posX+NODE_HALFSIZE, endNode.posY+NODE_HALFSIZE);

    context.lineWidth = ARC_WIDTH;
    context.lineJoin = 'butt';



    if (endNode.nodeLevel >= startNode.nodeLevel) {
      let x1 = startNode.posX + NODE_HALFSIZE;
      let y1 = startNode.posY + NODE_HALFSIZE;
      let x2 = endNode.posX + NODE_HALFSIZE;
      let y2 = endNode.posY + NODE_HALFSIZE;

      context.strokeStyle = ARC_COLOR;
      context.fillStyle = ARC_COLOR; // for the triangle fill
      //draw straight line
      context.beginPath();
      context.moveTo(x1, y1);
      context.lineTo(x2, y2);
      context.stroke();

      /*
// draw the starting arrowhead
var startRadians=Math.atan((y2-y1)/(x2-x1));
startRadians+=((x2>x1)?-90:90)*Math.PI/180;
console.log(startRadians);
if (startRadians==Math.PI) startRadians = 0;
drawArrowhead(context,x1,y1,startRadians);
*/

      // draw the ending arrowhead
      var endRadians = Math.atan((y2 - y1) / (x2 - x1));
      endRadians += ((x2 > x1) ? 90 : -90) * Math.PI / 180;
      if (endRadians === 0) endRadians = Math.PI;

      x2 = x2 - Math.sin(endRadians) * NODE_HALFSIZE;
      y2 = y2 + Math.cos(endRadians) * NODE_HALFSIZE;

      drawArrowhead(context, x2, y2, endRadians);
      drawArrowText(context, arc, startNode, endNode);

      let poly = [];
      poly.push([x2 - lineThick, y2]);
      poly.push([x1 - lineThick, y1]);
      poly.push([x1 + lineThick, y1]);
      poly.push([x2 + lineThick, y2]);
      lines.push({
        label: arc.testo,
        idNodo: startNode.idNodo,
        idArco: arc.idArco,
        polygon: poly
      });
      /*
              context.beginPath();
              context.moveTo(poly[0][0], poly[0][1]);
              context.lineTo(poly[1][0], poly[1][1]);
              context.lineTo(poly[2][0], poly[2][1]);
              context.lineTo(poly[3][0], poly[3][1]);
              context.lineTo(poly[0][0], poly[0][1]);
              context.closePath();
              context.stroke();
      */
    }
    else {
      let x2 = startNode.posX + NODE_HALFSIZE;
      let y2 = startNode.posY + NODE_HALFSIZE;
      let x1 = endNode.posX + NODE_HALFSIZE;
      let y1 = endNode.posY + NODE_HALFSIZE;

      context.strokeStyle = ARC_INV_COLOR;
      context.fillStyle = ARC_INV_COLOR; // for the triangle fill
      //draw arc
      let sx = x1;
      let sy = y1;
      let px1 = x1 - ((x1 - x2) / 2);
      let py1 = y1;
      let px2 = x2;
      let py2 = y2 - ((y2 - y1) / 2);
      let dx = x2;
      let dy = y2 - NODE_HALFSIZE;
      context.beginPath();
      context.moveTo(sx, sy);
      context.bezierCurveTo(px1, py1, px2, py2, dx, dy);
      context.stroke();
    }

  }
}


function drawArrowhead(ctx, x, y, radians) {
  ctx.save();
  ctx.beginPath();
  ctx.translate(x, y);
  ctx.rotate(radians);
  ctx.moveTo(0, 0);
  ctx.lineTo((ARC_ARROW_SIZE / 2), ARC_ARROW_SIZE);
  ctx.lineTo(-(ARC_ARROW_SIZE / 2), ARC_ARROW_SIZE);
  ctx.closePath();
  ctx.restore();
  ctx.fill();
}

function drawArrowText(ctx, arc, startNode, endNode) {

  ctx.save();

  ctx.beginPath();
  let sX = startNode.posX + NODE_HALFSIZE;
  let sY = startNode.posY + NODE_HALFSIZE;
  let eX = endNode.posX + NODE_HALFSIZE;
  let eY = endNode.posY + NODE_HALFSIZE;

  let padd = 5;
  sX = sX + padd;
  sY = sY - padd;
  eX = eX + padd;
  eY = eY - padd;
  let angle = angleBetweenPoints(sX, sY, eX, eY);
  if (endNode.posX < startNode.posX) {
    sX = sX - padd;
    sY = sY - padd;
    eX = eX - padd;
    eY = eY - padd;
    angle = angleBetweenPoints(sX, sY, eX, eY) + Math.PI;//  -angleBetweenPoints(sX, sY, eX, eY);
  }

  let posX = sX + (eX - sX) / 2;
  let posY = sY + (eY - sY) / 2;

  //ctx.rect(0, 0, 200, 50);
  //ctx.fillStyle="#FF0000";
  //ctx.fillRect(0, 0, 200, 50);
  ctx.font = ARC_TEXT_SIZE + "px Arial";
  ctx.fillStyle = ARC_TEXT_COLOR;
  ctx.textAlign = "center";
  ctx.translate(posX, posY);
  ctx.rotate(angle);
  ctx.fillText(arc.testo.slice(0, 10) + "...", 0, 0);
  //ctx.clip();
  ctx.closePath();

  ctx.restore();
}



function processNodeRecursive(context, node, parentNode, nodeSize) {

  if (node != null) {
    if (parentNode != null) {
      if (parentNode.children != null && parentNode.children.length > 1) {
        if (isNaN(lastOffsetForLevel[node.nodeLevel])) {
          //console.log(node.descNodo+"  prevOffLev=0");
          lastOffsetForLevel[node.nodeLevel] = node.weight;
        }
        else {
          //console.log(node.descNodo+"  prevOffLev="+lastOffsetForLevel[node.nodeLevel]);
          lastOffsetForLevel[node.nodeLevel] += node.weight;
        }
        node.offsetForLevel = lastOffsetForLevel[node.nodeLevel];
        //console.log(node.descNodo+"  nextOffLev="+node.offsetForLevel);       
      }
      else {
        //console.log(node.descNodo+"  get parent offLev=");       
        node.offsetForLevel = parentNode.offsetForLevel;
        lastOffsetForLevel[node.nodeLevel]++;
      }
    }
    else {
      node.offsetForLevel = totalWeight;
    }


    calculateNodePos(context, node, nodeSize);
    if (node.children != null && node.children.length > 0) {
      for (var i = 0; i < node.children.length; i++) {
        processNodeRecursive(context, node.children[i], node, nodeSize);
      }
    }
  }
  else
    console.log("processNodeRecursive NO NODE");
}

function calculateNodePos(context, node, nodeSize) {
  if (node != null) {
    let offsetX = (node.offsetForLevel - node.weight) * (NODE_SIZE + NODE_SPACE_X);
    let cX = ((node.weight / totalWeight) * totalSizeW) / 2;
    let posX = offsetX + cX - NODE_HALFSIZE;
    let posY = node.nodeLevel > 0 ? ((node.nodeLevel) * (nodeSize + NODE_SPACE_Y) + NODE_SPACE_Y) : nodeSize;
    node.posX = posX;
    node.posY = posY;
    //console.log( node.descNodo+"    posX="+posX+"   posY="+posY +"   offL="+node.offsetForLevel);
  }
}



function normalizeGrafo() {
  //console.log("normalizeGrafo start");
  maxTreeLevels = 0;
  if (data != null && data.nodi != null) {
    clonedData = data.nodi.slice();
    //console.log(clonedData);
    if (clonedData != null && clonedData.length > 0) {
      normData = clonedData[0];
      if (normData != null) {
        normData.nodeLevel = 0;
        normalizeRecursive(normData);
      }
    }
  }
  else {
    console.log("normalizeGrafo no data");
  }

}

function calculateWeight(nodo) {
  let weight = 0;
  if (nodo != null) {
    if (nodo.children != null && nodo.children.length > 0) {
      for (var i = 0; i < nodo.children.length; i++) {
        weight = weight + calculateWeight(nodo.children[i]);
      }
    }
    else {
      weight = 1;
    }
    nodo.weight = weight;
  }
  return weight;
}

function normalizeRecursive(nodo) {
  if (nodo != null) {
    let nNode = normalizeNodo(nodo);
    if (nNode.children != null && nNode.children.length > 0) {
      for (var i = 0; i < nNode.children.length; i++) {
        normalizeRecursive(nNode.children[i]);
      }
    }
    if (nNode.nodeLevel > maxTreeLevels) {
      maxTreeLevels = nNode.nodeLevel;
    }
  }
}

function normalizeNodo(nodo) {
  if (nodo != null) {
    if (nodo.archi != null && nodo.archi.length > 0) {
      for (var i = 0; i < nodo.archi.length; i++) {
        let arc = nodo.archi[i];
        if (arc != null) {
          let nodoEnd = findNodo(arc.idNodoEnd);
          if (nodoEnd != null) {
            if (!(nodoEnd.hasOwnProperty("processedAsChildren") && nodoEnd.processedAsChildren === true)) {
              nodoEnd.processedAsChildren = true;
              nodoEnd.nodeLevel = nodo.nodeLevel + 1;
              //add as children
              if (nodo.children == null) {
                nodo.children = [];
              }
              nodo.children.push(nodoEnd);
            }
          }
          else {
            console.warn("normalizeNodo end node not found with id " + arc.idNodoEnd);
          }
        }
        else {
          console.warn("normalizeNodo arco is null");
        }
      }
    }
    else {
      //foglia
      //console.log("normalizeNodo no archi found for "+nodo.idNodo);
    }
  }
  else {
    console.warn("normalizeNodo nodo is null");
  }
  return nodo;
}

export function findNodo(idNodo) {
  let result = null;
  if (data != null && data.nodi != null && data.nodi.length > 0) {
    for (var i = 0; i < data.nodi.length; i++) {
      let nodo = data.nodi[i];
      if (nodo.idNodo === idNodo) {
        result = nodo;
        break;
      }
    }
  }
  return result;
}

export function nodeInCoord(x, y, canvasScale, canvasTransform) {
  let result = null;

  if (clonedData != null && clonedData.length > 0) {
    if (isNaN(canvasScale)) canvasScale = 1;
    let sW = NODE_SIZE * canvasScale;
    let sH = NODE_SIZE * canvasScale;
    let tX = canvasTransform != null && canvasTransform !== "undefined" ? canvasTransform.x : 0;
    let tY = canvasTransform != null && canvasTransform !== "undefined" ? canvasTransform.y : 0;
    for (var i = 0; i < clonedData.length; i++) {
      let nodo = clonedData[i];
      let nX = (nodo.posX * canvasScale) + tX;
      let nY = (nodo.posY * canvasScale) + tY;
      //console.log("nodo.posX="+nodo.posX+"  px="+nX+"  scale="+canvasScale)

      if (
        (x >= (nX) && x <= (nX + sW)) &&
        (y >= (nY) && y <= (nY + sH))
      ) {
        result = nodo;
        break;
      }
    }
  }
  return result;
}

export function arcInCoord(x, y, canvasScale, canvasTransform) {
  let result = null;

  if (lines != null && lines.length > 0) {
    if (isNaN(canvasScale)) canvasScale = 1;
    let tX = canvasTransform != null && canvasTransform !== "undefined" ? canvasTransform.x : 0;
    let tY = canvasTransform != null && canvasTransform !== "undefined" ? canvasTransform.y : 0;
    for (var i = 0; i < lines.length; i++) {
      let line = lines[i];
      if (line.polygon != null && line.polygon.length > 0) {
        let newPoly = [];
        for (let j = 0; j < line.polygon.length; j++) {
          let px = (line.polygon[j][0] * canvasScale) + tX;
          let py = (line.polygon[j][1] * canvasScale) + tY;
          newPoly.push([px, py]);
        }
        if (pointInPolygon([x, y], newPoly)) {
          result = line;
          break;
        }
      }
    }
  }
  return result;
}

function pointInPolygon(point, polygon) {
  //A point is in a polygon if a line from the point to infinity crosses the polygon an odd number of times
  let odd = false;
  //For each edge (In this case for each point of the polygon and the previous one)
  for (let i = 0, j = polygon.length - 1; i < polygon.length; i++) {
    //If a line from the point into infinity crosses this edge
    if (((polygon[i][1] > point[1]) !== (polygon[j][1] > point[1])) // One point needs to be above, one below our y coordinate
      // ...and the edge doesn't cross our Y corrdinate before our x coordinate (but between our x coordinate and infinity)
      && (point[0] < ((polygon[j][0] - polygon[i][0]) * (point[1] - polygon[i][1]) / (polygon[j][1] - polygon[i][1]) + polygon[i][0]))) {
      // Invert odd
      odd = !odd;
    }
    j = i;

  }
  //If the number of crossings was odd, the point is in the polygon
  return odd;
};

function angleBetweenPoints(cx, cy, ex, ey) {
  var dy = ey - cy;
  var dx = ex - cx;
  var theta = Math.atan2(dy, dx); // range (-PI, PI]
  //theta *= 180 / Math.PI; // rads to degs, range (-180, 180]
  //if (theta < 0) theta = 360 + theta; // range [0, 360)
  return theta;
}

